<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onHidden)="onHidden()"
  modalTitle="Salvar Mapa"
  width="25rem"
  height="21rem"
>
  <ng-template modalContent>
    <form
      class="form-register"
      [formGroup]="formGroup"
      (ngSubmit)="onSubmit($event)"
    >
      <div class="fields-container">
        <div class="field-set">
          <label label>Nome do Mapa*</label>

          <app-input-box
            formControlName="name"
            [autocomplete]="false"
            [maxLength]="nameMaxLength"
            [showErrorEnabled]="false"
          ></app-input-box>
        </div>

        <div class="field-set">
          <label label>Descrição*</label>

          <app-text-area
            formControlName="description"
            [maxLength]="descriptionMaxLength"
            [rows]="3"
            resize="none"
            [showErrorEnabled]="false"
          ></app-text-area>
        </div>
      </div>

      <div class="actions-bottom">
        <app-button
          type="submit"
          buttonType="primary"
          styleType="contained"
          text="Salvar"
          [disabled]="formGroup.invalid"
          width="100%"
        ></app-button>
      </div>
    </form>
  </ng-template>
</app-modal>
